import DefaultFactory from "/scripts/default/factory";
import UIHero from "/components/ui/hero";
import UIIntro from "/components/ui/intro";
import UIButton from "/components/ui/dashboard/button";
import UICheckbox from "/components/ui/dashboard/checkbox";
import UICursor from "/components/ui/dashboard/cursor";
import UIFlower from "/components/ui/dashboard/flower";
import UIRange from "/components/ui/dashboard/range";
import UIToggle from "/components/ui/dashboard/toggle";
import UIDraggable from "/components/ui/draggable";
import UIFlip from "/components/ui/flip";

/*
	Individual page factories follow the same principles as
	the global factory in /public/scripts/index.js but contain
	blocks that should only be checked for on a single page
*/
class UIFactory extends DefaultFactory {
	createBlock(blockName, block) {
		switch (blockName) {
			case "ui-hero":
				return new UIHero(block);
			case "ui-intro":
				return new UIIntro(block);
			case "ui-button":
				return new UIButton(block);
			case "ui-checkbox":
				return new UICheckbox(block);
			case "ui-cursor":
				return new UICursor(block);
			case "ui-flower":
				return new UIFlower(block);
			case "ui-range":
				return new UIRange(block);
			case "ui-toggle":
				return new UIToggle(block);
			case "ui-draggable":
				return new UIDraggable(block);
			case "ui-flip":
				return new UIFlip(block);
			default:
				return null;
		}
	}
}

new UIFactory();
